import {
    GET_ROUTE_LIST_PROGRESS, GET_ROUTE_LIST_SUCCESS, GET_ROUTE_LIST_FAILURE,
    ADD_ROUTE_PROGRESS, ADD_ROUTE_SUCCESS, ADD_ROUTE_FAILURE,
    EDIT_DELETE_ROUTE_PROGRESS, EDIT_DELETE_ROUTE_SUCCESS, EDIT_DELETE_ROUTE_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    route: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const route_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_ROUTE_LIST_SUCCESS:
            return { ...state, route: action.route, loading: false };
        case GET_ROUTE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_ROUTE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_ROUTE_PROGRESS:
            return { ...state, loading: true };
        case ADD_ROUTE_SUCCESS:
            return { ...state, route: [...state.route, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_ROUTE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_ROUTE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_ROUTE_SUCCESS:
            return {
                ...state,
                route: state.route.map((route) =>
                    route.id === action.payload.id ? action.payload : route
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_ROUTE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default route_reducer;